<script lang="ts" setup>
  import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant';
  import { useThemeConfig } from '@core/composable/useThemeConfig';

  import SupportFab from '@/components/support/SupportFab.vue';
  import Footer from '@/layouts/components/Footer.vue';
  import HorizontalUserProfile from '@/layouts/components/HorizontalUserProfile.vue';
  import NavbarThemeSwitcher from '@/layouts/components/NavbarThemeSwitcher.vue';
  import { useHorizontalNavByRole } from '@/navigation/horizontal';
  import { useAuthStore } from '@/stores/agency/auth';
  import { useAgencyStore } from '@/stores/agency/settings/agency/profile';
  import { HorizontalNavLayout } from '@layouts';
  import { HorizontalNav } from '@layouts/components';

  const { appRouteTransition } = useThemeConfig();
  const agencyStore = useAgencyStore();
  const authStore = useAuthStore();
  const role = computed(() => authStore.getCurrentTenantRole || '');
  const navItems = computed(() => useHorizontalNavByRole(role.value));
  const defaultAgencyLogo = useGenerateImageVariant(agencyStore.logo, agencyStore.logoDark);
  const agencyLogoSrc = computed(() => agencyStore.agencyProfile.agencyLogo || defaultAgencyLogo.value);
</script>

<template>
  <HorizontalNavLayout :nav-items="navItems">
    <!-- 👉 navbar -->
    <template #navbar>
      <RouterLink :to="{ name: 'agency-home' }" class="app-logo d-flex align-center gap-x-3">
        <img :src="agencyLogoSrc" style="height: 45px" alt="Agency logo" />
      </RouterLink>

      <VSpacer />
      <div class="layout-horizontal-nav">
        <div class="horizontal-nav-content-container">
          <HorizontalNav :nav-items="navItems" />
        </div>
      </div>
      <VSpacer />

      <NavbarThemeSwitcher class="me-2" />
      <ChangeLog class="me-2" />
      <Notifications class="me-5" />
      <HorizontalUserProfile :is-minimal="['Point of Contact'].includes(role)" />
    </template>

    <!-- 👉 Pages -->
    <RouterView v-slot="{ Component }">
      <Transition :name="appRouteTransition" mode="out-in">
        <Component :is="Component" />
      </Transition>
    </RouterView>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </HorizontalNavLayout>

  <SupportFab />
</template>
